export const TIME_OUT_MS = 30000;
export const APP_NAME = "PICK ONE";

export const TEST_USER_ID = 'shuya.yokozawa';
